"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.keys = keys;
function keys(object) {
    return Object.keys(object);
}
